// extracted by mini-css-extract-plugin
module.exports = {"label":"_6f25b66c20--label--2XM--","text":"_6f25b66c20--text--1lS4G","content":"_6f25b66c20--content--33sf5"};